module.exports = __webpack_public_path__ + "static/img/稀土.b4c0320.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/稀土.jpg
// module id = r8+M
// module chunks = 1